<template>

        <div class="global-map">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p class="global-map__ttl">{{activeRegion.name}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                            <div id="boxscroll">
                                <ul class="header-country-list">
                                    <li v-for="(item, index) in countriesList" :key="index">
                                        <a :href="'/countries/' + item.slug">{{item.name}}</a>
                                    </li>
                                </ul>
                            </div>
                    </div>
                    <div class="col">
                        <figure class="world-map">
                            <a v-for="(item, index) in regions" 
                            :key="index" href="#" 
                            :class="{ 'world-map__link' : true, ['world-map__link--link'+(index+1)]:true, 'active' :  item.id == activeRegion.id}"
                            @click.prevent="setCountry(item)">{{item.name}}</a>
                        </figure>
                    </div>
                </div>
                <!-- row -->
            </div>
        </div>
        <!-- global-map -->
</template>

<script>
    export default {
        data(){
            return {
                regions:[
                    {name:"Північна і Центральна Америка",id:'north_america'},
                    {name:"Кариби і Мексика",id:'carrib_islands'},
                    {name:"Південна Америка",id:'south_america'},
                    {name:"Європа",id:'europe'},
                    {name:"Африка",id:'africa'},
                    {name:"Індійський океан",id:'indian_ocean'},
                    {name:"Азія",id:'azia'},
                    {name:"Австралія і Тихий океан",id:'australia'}
                ],
                countries:[],
                activeRegion: {
                    name:"Європа",
                    id:'europe'
                }
            }
        },
        computed:{
            countriesList(){
                let self = this;
                let list = [];
                list = this.countries.filter(function(item) {
                    if (item.region) {
                        return item.region === self.activeRegion.id ? true : false;
                    } else {
                        return false;
                    }
                });
                this.initScroll();
                return list;
            }
        },
        methods:{
            initScroll(){
                $("#boxscroll").getNiceScroll().remove();
                setTimeout(function () {
                     $("#boxscroll").niceScroll({cursorborder:"#bfbfbf",cursorcolor:"#4a4a4a",boxzoom:false,cursoropacitymin: 0.3,autohidemode: false });
                },300);
            },
            setCountry(el){
                this.activeRegion = el;
               
            }
        },
        mounted() {
            axios.post("/countries-for-header").then(response => {
                this.countries = response.data;
            });
        }
    }
</script>
<style lang="css">
    .wrapper {
        position: relative;
        height: 320px;
        overflow-y: auto;
        margin: 20px 0 16px;
    }
/*The Wrapper*/
.my-scrollbar{
  /* width: 35%;
  min-width: 300px;
  max-height: 450px; */
}

/*The Content*/
.scroll-me{
  /* min-width: 750px; */
}
#boxscroll {
	position: relative;
    height: 320px;
    overflow-y: auto;
    margin: 20px 0 16px;
}
.nicescroll-rails.nicescroll-rails-vr{
    z-index: 10;
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MapCountry.vue